import { ChangeDetectionStrategy, Component, effect, inject, input, output, Signal, signal, ViewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule, DrawerComponent, MessageType } from '../../../../lib';
import { QF_DEFAULT_VALUES_MOCK } from '../../mock/qf.default-values.mock';
import { ContextModelState, QuestionFlowComponent } from '../../../question-flow';
import { DefaultValues } from '../../models/default-values.interface';
import { BuildingService } from '../../services';

@Component({
    selector: 'ca-rbr-default-values',
    templateUrl: './default-values.component.html',
    styleUrls: ['./default-values.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, ComponentsModule, QuestionFlowComponent]
})
export class DefaultValuesComponent {
    readonly messageTypes = MessageType;
    readonly qfDefaultValues = QF_DEFAULT_VALUES_MOCK as any;
    @ViewChild('drawer') drawer: DrawerComponent;

    readonly buildingService = inject(BuildingService);
    headerText = input<string>('RBR.DEFAULT_VALUES.TITLE');
    defaultValues = input.required<DefaultValues>();
    confirm = output<DefaultValues>();

    questionFlowContext = signal<ContextModelState>({});

    defaultValuesEffect = effect(() => {
        this.questionFlowContext.set({
            project: {
                building: {
                    buildingLevelHeight: this.defaultValues().levelHeight,
                    standardTypeOfWindow: this.defaultValues().typeOfWindow,
                    standardTypeOfSunProtection: this.defaultValues().typeOfSunProtection
                }
            }
        });
    });

    confirmEffect = effect(() => {
        if (!this.buildingService.drawerLoading()) {
            this.drawer?.close();
        }
    });

    onContextChange(context: ContextModelState): void {
        this.questionFlowContext.set(context);
    }

    onCancel(): void {
        this.drawer.close();
    }

    onConfirm(): void {
        const context = this.questionFlowContext();

        const defaultValues = {
            levelHeight: context.project.building.buildingLevelHeight,
            typeOfWindow: context.project.building.standardTypeOfWindow,
            typeOfSunProtection: context.project.building.standardTypeOfSunProtection
        } as DefaultValues;

        this.confirm.emit(defaultValues);
    }
}
